import React, { useState } from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import TotalCardContent from '../../../../../../components/NovoSistema/TotalCardContent';
import { TotalCardHeader } from '../../../../../../components/NovoSistema/TotalCardHeader';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import Legends from '../../../../../../components/NovoSistema/Legends';

export default function ContasAReceberSearch() {
  const [showOrHideSearch, setShowOrHideSearch] = useState(false);
  const [showOrHideTotal, setShowOrHideTotal] = useState(false);
  return (
    <div>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideSearch((e) => !e)}>{showOrHideSearch ? '- ' : '+ '}Pesquisas</h3>
        {showOrHideSearch && (
          <div>
            <WrapperInputsNewSystem>
              <InputText title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="45%" />
              <InputText title="Nro Documento" id="NroDocumento" widthPercentage="22%" />
              <SelectAndOptions
                title="Origem"
                id="Origem"
                optionsArray={[
                  '',
                  'Todas',
                  'CT-e',
                  'Faturamento',
                  'Financeiro',
                  'PDV',
                  'Serviços',
                  'Importado',
                  'Import NF-e',
                ]}
                widthPercentage="22%"
              />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
              <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
              <InputDate title="Vencimento Inicial" id="VencimentoInicial" widthPercentage="20%" />
              <InputDate title="Vencimento Final" id="VencimentoFinal" widthPercentage="20%" />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputDate title="Recebimento Inicial" id="RecebimentoInicial" widthPercentage="20%" />
              <InputDate title="Recebimento Final" id="RecebimentoFinal" widthPercentage="20%" />
              <SelectAndOptions
                title="Forma de Pagamento"
                id="FormaDePagamento"
                optionsArray={[
                  '',
                  'Dinheiro',
                  'Cheque',
                  'Cartão Crédito',
                  'Cartão Débito',
                  'Transferência DOC',
                  'Transferência TED',
                  'Boleto',
                  'Voucher',
                  'Troca',
                  'Conta',
                  'Débito Automático',
                ]}
                widthPercentage="20%"
              />
              <SelectAndOptions
                title="Categoria"
                id="Categoria"
                optionsArray={[
                  '',
                  'Ajuste de Caixa - Receita',
                  'Aplicações Financeiras',
                  'Empréstimos',
                  'Outras Receitas',
                  'Venda de Ativo Imobilizado',
                  'Vendas',
                ]}
                widthPercentage="20%"
              />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <SelectAndOptions
                title="Conta Bancária"
                id="ContaBancaria"
                optionsArray={['', '999 | 9999 | 9999-9 | Caixinha']}
                widthPercentage="20%"
              />
              <SelectAndOptions
                title="Conta Bancária Baixa"
                id="ContaBancariaBaixa"
                optionsArray={['', '999 | 9999 | 9999-9 | Caixinha']}
                widthPercentage="20%"
              />
              <InputText title="Nro Baixa" id="NroBaixa" widthPercentage="20%" />
              <InputText title="Nro Lote" id="NroLote" widthPercentage="20%" />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputText title="Valor Inicial" id="ValorInicial" widthPercentage="20%" />
              <InputText title="Valor Final" id="ValorFinal" widthPercentage="20%" />
              <InputText title="Nosso número Inicial" id="NossoNumeroInicial" widthPercentage="20%" />
              <InputText title="Nosso número Final" id="NossoNumeroFinal" widthPercentage="20%" />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputText title="Vendedor" id="Vendedor" widthPercentage="20%" />
              <InputCheckBox title="Somente Renegociados" id="SomenteRenegociados" />
            </WrapperInputsNewSystem>
            <div>
              <h4>Situação</h4>
              <WrapperInputsNewSystem>
                <InputCheckBox title="Todas" id="Todas" />
                <InputCheckBox title="Aberto" id="Aberto" />
                <InputCheckBox title="Quitado" id="Quitado" />
                <InputCheckBox title="Vencido" id="Vencido" />
                <InputCheckBox title="Vencendo Hoje" id="VencendoHoje" />
                <InputCheckBox title="Baixado Parcial" id="BaixadoParcial" />
                <InputCheckBox title="Cancelado" id="Cancelado" />
              </WrapperInputsNewSystem>
            </div>
            <ButtonsSearch />
          </div>
        )}
      </ContainerSection>

      <ContainerSection>
        <h3 onClick={() => setShowOrHideTotal((e) => !e)}>{showOrHideTotal ? '-  ' : '+ '}Total</h3>
        {showOrHideTotal && (
          <div>
            <TotalCardHeader>
              <p>Qtd. Selecionada para Baixa: 0 Valor Total: 0,00</p>
            </TotalCardHeader>
            <TotalCardContent />
          </div>
        )}
      </ContainerSection>

      <ContainerSection>
        <h3>Legenda</h3>
        <Legends
          itens={[
            { text: 'Aberto', color: 'blue' },
            { text: 'Baixado parcialmente', color: 'lightBlue' },
            { text: 'Quitado', color: 'green' },
            { text: 'Vencendo hoje', color: 'yellow' },
            { text: 'Vencido', color: 'red' },
            { text: 'Cancelado', color: 'gray' },
          ]}
        />
      </ContainerSection>
    </div>
  );
}
